/* eslint-disable react/jsx-filename-extension */
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { formatDeliveryEstimation } from '../resources/delivery-estimation-formatter/deliveryEstimationFormatter';

import componentStyles from './DeliveryEstimationHero.module.less';

const DeliveryEstimationHero = ({ deliveryEstimation, styles }) => {
  const derivedStyles = { ...componentStyles, ...styles };
  const { locale } = useIntl();
  function getDeliveryEstimation() {
    const translationOptions = {
      params: { estimationClassNames: derivedStyles.estimation },
      keySuffix: 'should-arrive',
    };
    return formatDeliveryEstimation(deliveryEstimation, { locale, translationOptions });
  }

  return (
    <div className={derivedStyles['delivery-estimation-hero']}>
      {/* eslint-disable-next-line react/no-danger */}
      {getDeliveryEstimation()}
    </div>
  );
};

DeliveryEstimationHero.propTypes = {
  deliveryEstimation: PropTypes.shape({
    duration: PropTypes.shape({
      min: PropTypes.string,
      max: PropTypes.string,
    }),
    providerGivesEstimate: PropTypes.bool,
  }).isRequired,
  styles: PropTypes.shape({
    'delivery-estimation-hero': PropTypes.string,
  }),
};

DeliveryEstimationHero.defaultProps = {
  styles: {},
};

export default DeliveryEstimationHero;
